import React, { PureComponent } from 'react';
import { func, shape } from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Form } from 'antd';
import { AppWrappperHOC } from '../Root/HOC';
import { indusindKuberCardsFaqSuccess } from '../IndusindZingerCardsFaqs/selectors';
import { indusindKuberCardFaQ } from '../IndusindZingerCardsFaqs/actions';
import { FaQs } from '../NetworkCards/FaQs';

class IndusindKuberCardsFaQs extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const {
      onindusindBankKuberCardsFaQ,
    } = this.props;
    onindusindBankKuberCardsFaQ();
  }

  render() {
    const {
      isIndusindKuberFaq = {},
    } = this.props;
    return (
      <FaQs
        Faq={isIndusindKuberFaq}
        name="Indusind Kuber Card FAQs"
      />
    );
  }
}

IndusindKuberCardsFaQs.propTypes = {
  isIndusindKuberFaq: shape({}).isRequired,
  onindusindBankKuberCardsFaQ: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onindusindBankKuberCardsFaQ: () => dispatch(indusindKuberCardFaQ()),
});

const mapStateToProps = createStructuredSelector({
  isIndusindKuberFaq: indusindKuberCardsFaqSuccess(),
});

const IndusindKuberCardsFaQsWrapper = Form.create({ name: 'normal_admin' })(IndusindKuberCardsFaQs);
export default connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(IndusindKuberCardsFaQsWrapper));
export { IndusindKuberCardsFaQs, IndusindKuberCardsFaQsWrapper };



// WEBPACK FOOTER //
// client/containers/IndusindKuberCardsFaq/index.js